import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import { requests, statusLabels, statusOrder, type RequestStatus } from '../../data/demandes';
export function StatusProgress({
  status
}: {
  status: RequestStatus;
}) {
  const currentIndex = statusOrder.indexOf(status);
  return <ol className="flex items-center gap-2" aria-label={`Status: ${statusLabels[status]}`} data-id="element-944" data-mp="evmh9j1uqxh1">
      {statusOrder.map((step, index) => {
      const reached = index <= currentIndex;
      return <li key={step} className="flex items-center gap-2" data-id="element-945" data-mp="ntewyobhk74y" data-mpi={index}>
            <span className={`rounded-full px-3 py-1 text-xs font-bold ${index === currentIndex ? 'bg-ville-indigo text-white' : reached ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-100 text-slate-400'}`} data-id="element-946" data-mp="su2nl8vsylyn">
              {statusLabels[step]}
            </span>
            {index < statusOrder.length - 1 && <span className={`h-0.5 w-5 rounded-full ${index < currentIndex ? 'bg-ville-indigo' : 'bg-slate-200'}`} aria-hidden="true" data-id="element-947" data-mp="2zjqz7zsrqo8p" />}
          </li>;
    })}
    </ol>;
}
export function RequestList() {
  return <section aria-labelledby="my-requests-title" data-id="element-948" data-mp="id3nfo4edq12">
      <h2 id="my-requests-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-949" data-mp="icamx4w17wrd">
        My requests
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-950" data-mp="9d75s6gfdrfi">Follow the progress of what you have reported.</p>

      <ul className="mt-6 space-y-3" data-id="element-951" data-mp="162xz42czd8jq">
        {requests.map(request => <li key={request.id} data-id="element-952" data-mp="1613phk75t2uy">
            <Link to={`/my-requests/${request.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-953" data-mp="114czo55jyswc">
              <div className="min-w-0 flex-1" data-id="element-954" data-mp="3hsh6pb8kwqlp">
                <div className="flex flex-wrap items-center gap-2" data-id="element-955" data-mp="3hubpok0ai8n5">
                  <h3 className="text-[15px] font-extrabold text-ville-navy" data-id="element-956" data-mp="3cte7i7fa5eln">{request.title}</h3>
                  <span className="text-xs font-semibold text-slate-400" data-id="element-957" data-mp="3eajovt2ibn7h">{request.reference}</span>
                </div>
                <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-958" data-mp="3j8l7kcw0tkif">
                  <span className="flex items-center gap-1.5" data-id="element-959" data-mp="359lhd0sv0xk5">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-960" data-mp="39b6zb0k94217" />
                    {request.address}
                  </span>
                  <span data-id="element-961" data-mp="2viqupvbpbvy6">{request.submittedOn}</span>
                </p>
                <div className="mt-3" data-id="element-962" data-mp="30bbjgifr3iuu">
                  <StatusProgress status={request.status} data-id="element-963" data-mp="30ccysz3surid" />
                </div>
              </div>
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-964" data-mp="2lnyvyo6dv31t" />
            </Link>
          </li>)}
      </ul>
    </section>;
}